import React from 'react';
import { Trophy, Calendar, Star } from 'lucide-react';
import { useGame } from '../contexts/GameContext';

const Leaderboard = () => {
  const { highScores } = useGame();
  
  // Function to format date
  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      return new Intl.DateTimeFormat('ug-CN', { 
        year: 'numeric', 
        month: 'short', 
        day: 'numeric' 
      }).format(date);
    } catch (e) {
      return dateString;
    }
  };
  
  return (
    <div className="game-card">
      <h2 className="text-xl font-semibold mb-6 flex items-center uyghur-text">
        <Trophy size={24} className="text-yellow-500 mr-2" />
        ئەڭ يۇقىرى نومۇرلار
      </h2>
      
      {highScores.length === 0 ? (
        <div className="text-center py-12">
          <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <Star size={32} className="text-gray-400" />
          </div>
          <p className="text-gray-500 uyghur-text">تېخى ھېچقانداق رېكورت يوق</p>
          <p className="text-gray-400 text-sm mt-2 uyghur-text">
            ئويۇن ئويناپ، رېكورت يارىتىڭ!
          </p>
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-gray-200">
                <th className="px-4 py-2 text-left text-gray-600">#</th>
                <th className="px-4 py-2 text-left text-gray-600 uyghur-text">نومۇر</th>
                <th className="px-4 py-2 text-left text-gray-600 uyghur-text">سۆز سانى</th>
                <th className="px-4 py-2 text-left text-gray-600 uyghur-text">ۋاقىت</th>
              </tr>
            </thead>
            <tbody>
              {highScores.map((score, index) => (
                <tr 
                  key={index} 
                  className={`border-b border-gray-100 ${
                    index === 0 ? 'bg-yellow-50' : index < 3 ? 'bg-gray-50' : ''
                  }`}
                >
                  <td className="px-4 py-3">
                    {index === 0 && <Trophy size={16} className="text-yellow-500" />}
                    {index === 1 && <Trophy size={16} className="text-gray-400" />}
                    {index === 2 && <Trophy size={16} className="text-amber-600" />}
                    {index > 2 && (index + 1)}
                  </td>
                  <td className="px-4 py-3 font-bold text-emerald-600">
                    {score.score}
                  </td>
                  <td className="px-4 py-3 text-gray-600 uyghur-text">
                    {score.words} سۆز
                  </td>
                  <td className="px-4 py-3 text-gray-500 flex items-center text-sm">
                    <Calendar size={14} className="mr-1" />
                    <span>{formatDate(score.date)}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      
      <div className="mt-6 p-4 bg-blue-50 rounded-lg">
        <h3 className="font-medium text-blue-700 mb-2 uyghur-text">تەكلىپ-پىكىرلەر</h3>
        <p className="text-blue-600 text-sm uyghur-text">
          بۇ رېكورتلار سىزنىڭ ئۈسكۈنىڭىزدە ساقلىنىدۇ. ئەگەر ئويۇننى باشقا ئۈسكۈنىدە ئوينىسىڭىز، يېڭى رېكورت تىزىملىكى باشلىنىدۇ.
        </p>
      </div>
    </div>
  );
};

export default Leaderboard;